import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-accuracy-tier-update-search',
    templateUrl: './accuracy-tier-update-search.component.html',
    styleUrls: ['./accuracy-tier-update-search.component.scss'],
    standalone: false
})

export class AccuracyTierUpdateSearchComponent {
    
    @Input() view: 'contacts' | 'companies';
    @Input() accuracy_tier: 'HV' | 'EV' | 'MV' | '';
    @Input() disabled: boolean;
    @Input() allowMVAccuracySelection: boolean = true;
    @Input() MVAccuracyNotAllowedTooltipText: string;

    @Output() onChange: EventEmitter<'HV' | 'EV' | 'MV'> = new EventEmitter<'HV' | 'EV' | 'MV'>(); 

    isClickInsideCircle(event: MouseEvent) {
        const target = event.target as HTMLElement;
        return target.classList.contains('outer-circle') || target.classList.contains('inner-circle');
    }

    onContactsChange(event: MouseEvent, tier: 'HV' | 'EV' | 'MV'): void {
        if (!this.isClickInsideCircle(event)) {
            return;
        }
        if (tier === 'MV' && !this.allowMVAccuracySelection){
            return;
        }
        switch (this.accuracy_tier) {
            case 'MV':
                this.accuracy_tier = ['MV', 'EV'].includes(tier) ? 'EV' : 'HV';
                break;
            case 'HV':
                this.accuracy_tier = tier;
                break;
            case 'EV':
            default:
                this.accuracy_tier = ['HV', 'EV'].includes(tier) ? 'HV' : 'MV';
                break;
        }
        this.onChange.emit(this.accuracy_tier);
    }
    onCompaniesChange(event: MouseEvent, tier: 'HV' | 'MV'): void {
        if (!this.isClickInsideCircle(event)) {
            return;
        }
        switch (this.accuracy_tier) {
            case 'HV':
                this.accuracy_tier = tier;
                break;
            case 'MV':
            default:
                this.accuracy_tier = 'HV';
                break;
        }
        this.onChange.emit(this.accuracy_tier);
    }
}
